import { cBigNumber } from "../../classes/BigNumber";
import { iBalance, iClientOrderOption, iConfig, iConfigStrikes, iEOPTContract, iHistoryRecording, iOption, tTokenInfo } from "../../interfaces/interfaces";

export enum eAppActionTypes {
	CLEAR_STATE = 'APP/CLEAR_STATE',
	SET_USER_ADDRESS = 'APP/SET_USER_ADDRESS',
	SET_CONFIG = 'APP/SET_CONFIG',
	SET_API = 'APP/SET_API',
	SET_EOPT_CONTRACT = 'APP/SET_EOPT_CONTRACT',
	SET_TOKEN = 'APP/SET_TOKEN',
	SET_SYSTEM_TIMESTAMP = 'APP/SET_SYSTEM_TIMESTAMP',
	// SET_WEB3_PROVIDER = 'APP/SET_WEB3_PROVIDER',
	SET_IS_PRO = 'APP/SET_IS_PRO',
	SET_TOKEN_PRICE = 'APP/SET_TOKEN_PRICE',
	SET_CURRENT_OPTIONS = 'APP/SET_CURRENT_OPTIONS',
	SET_CLIENT_BALANCES = 'APP/SET_CLIENT_BALANCES',
	SET_CLIENT_ORDERS = 'APP/SET_CLIENT_ORDERS',
	SET_DARK_MODE = 'APP/SET_DARK_MODE',
	SET_IS_HISTORY_UPDATING = 'APP/SET_IS_HISTORY_UPDATING',
	SET_HISTORY_RECORDINGS = 'APP/SET_HISTORY_RECORDINGS',
	SET_ALL_OPTIONS = 'APP/SET_ALL_OPTIONS',
	SET_OPTIONS_PERIOD = 'APP/SET_OPTIONS_PERIOD',
	UPDATE_STRIKES = 'APP/UPDATE_STRIKES',
	SET_KAS_ACCESS_TOKEN = 'APP/SET_KAS_ACCESS_TOKEN',
    SET_CHR_NODE_URL = 'APP/SET_CHR_NODE_URL',
}

export type tAppAction =
	iClearAppStateAction |
	iSetUserAddressAction |
	iSetConfigAction |
	iSetApiAction |
	iSetEOPTContracAtction |
	iSetTokenAction |
	iSetSystemTimestampAction |
	// iSetWeb3ProviderAction |
	iSetisProAction |
	iSetTokenPriceAction |
	iSetCurrentOptionsAction |
	iSetClientBalancesAction |
	iSetClientOrdersAction |
	iSetDarkModeAction |
	iSetIsHistoryUpdatingAction |
	iSetHistoryRecordingsAction |
	iSetAllOptionsAction |
	iSetOptionsPeriodAction |
	iUpdateStrikesAction |
	iSetKASAccessTokenAction |
	iSetChrNodeUrlAction
;

interface iClearAppStateAction {
	type: eAppActionTypes.CLEAR_STATE,
}

interface iSetUserAddressAction {
	type: eAppActionTypes.SET_USER_ADDRESS,
	payload: string | null;
}

interface iSetConfigAction {
	type: eAppActionTypes.SET_CONFIG,
	payload: iConfig
}

interface iSetApiAction {
	type: eAppActionTypes.SET_API,
	payload: string
}

interface iSetEOPTContracAtction {
	type: eAppActionTypes.SET_EOPT_CONTRACT,
	payload: iEOPTContract
}

interface iSetTokenAction {
	type: eAppActionTypes.SET_TOKEN,
	payload: tTokenInfo
}

interface iSetSystemTimestampAction {
	type: eAppActionTypes.SET_SYSTEM_TIMESTAMP,
	payload: number
}

/* interface iSetWeb3ProviderAction {
	type: eAppActionTypes.SET_WEB3_PROVIDER,
	payload: iWeb3Provider
} */

interface iSetisProAction {
	type: eAppActionTypes.SET_IS_PRO,
	payload: boolean
}

interface iSetTokenPriceAction {
	type: eAppActionTypes.SET_TOKEN_PRICE,
	payload: {
		currency: string,
		price: cBigNumber
	}
}

interface iSetCurrentOptionsAction {
	type: eAppActionTypes.SET_CURRENT_OPTIONS,
	payload: iOption[]
}

interface iSetClientBalancesAction {
	type: eAppActionTypes.SET_CLIENT_BALANCES,
	payload: iBalance[]
}

interface iSetClientOrdersAction {
	type: eAppActionTypes.SET_CLIENT_ORDERS,
	// payload: iOrder[]
	payload: iClientOrderOption[]
}

interface iSetDarkModeAction {
	type: eAppActionTypes.SET_DARK_MODE,
	payload: boolean
}

interface iSetIsHistoryUpdatingAction {
	type: eAppActionTypes.SET_IS_HISTORY_UPDATING,
	payload: boolean
}

interface iSetHistoryRecordingsAction {
	type: eAppActionTypes.SET_HISTORY_RECORDINGS,
	payload: iHistoryRecording[]
}

interface iSetAllOptionsAction {
	type: eAppActionTypes.SET_ALL_OPTIONS,
	payload: iOption[]
}

interface iSetOptionsPeriodAction {
	type: eAppActionTypes.SET_OPTIONS_PERIOD,
	payload: 'all' | 'daily' | 'weekly' | 'non-standart'
}

interface iUpdateStrikesAction {
	type: eAppActionTypes.UPDATE_STRIKES,
	payload: iConfigStrikes
}

interface iSetKASAccessTokenAction {
	type: eAppActionTypes.SET_KAS_ACCESS_TOKEN,
	payload: string
}

interface iSetChrNodeUrlAction {
    type: eAppActionTypes.SET_CHR_NODE_URL;
    payload: string[];
}